<template>
  <div class="course-header-container">
    <headerMenu />
    <div class="course-header-breadcrumbs">
      <i
        class="mdi mdi-arrow-left course-header-back"
        @click="$router.back()"
      ></i>
      <v-breadcrumbs
        :items="getBreadcrumbs"
        divider=">"
        class="m-0"
      ></v-breadcrumbs>
    </div>
  </div>
</template>

<script>
import headerMenu from "@/components/headerMenu.vue";
import { mapGetters } from "vuex";

export default {
  props: ["data", "items"],
  components: {
    headerMenu,
  },
  computed: {
    ...mapGetters(["getBreadcrumbs"]),
  },
  data() {
    return {};
  },
};
</script>

<style></style>
